/**
 * What a customer page shows while its {@link PollController} has nothing to show yet: the
 * customer counterpart of load-state.js, without the backend's own words.
 *
 *     const pending = customerLoadState(this.poll);
 *     if (pending) return pending;
 */
import { html } from 'lit';

import { customerError } from '../i18n/customer-labels.js';

export function customerLoadState(poll) {
  if (poll.value !== undefined) {
    return null;
  }
  if (poll.error) {
    const notFound = poll.error.status === 404;
    return html`
      <div class="notice" data-tone=${notFound ? 'muted' : 'danger'} role="alert">
        <strong>${notFound ? 'Not found' : 'Could not load this page'}</strong>
        ${customerError(poll.error)} ${notFound ? html`<a href="/">Back to your workspaces</a>` : html`<button class="small" @click=${() => poll.refresh()}>Retry</button>`}
      </div>
    `;
  }
  return html`<p class="muted" aria-busy="true">Loading…</p>`;
}
